import { createAction, handleActions } from "redux-actions";

// ACTION TYPES
const ADDRESS_SEARCH = `${process.env.PUBLIC_URL}/ADDRESS/SEARCH`;
const UPDATE_STORE = `${process.env.PUBLIC_URL}/ADDRESS/UPDATE_STORE`;
const ESTADOS = `${process.env.PUBLIC_URL}/ADDRESS/STATES`;
const CIDADES = `${process.env.PUBLIC_URL}/ADDRESS/CITIES`;
const PROVINCIAS = `${process.env.PUBLIC_URL}/ADDRESS/PROVINCES`;
const TIPOS_VIA = `${process.env.PUBLIC_URL}/ADDRESS/STREET_TYPES`;

export const types = {
  ADDRESS_SEARCH,
  UPDATE_STORE,
  ESTADOS,
  CIDADES,
  PROVINCIAS,
  TIPOS_VIA,
};

// ACTIONS
const searchAddress = createAction(ADDRESS_SEARCH);
const updateAddressStore = createAction(UPDATE_STORE);
const getEstados = createAction(ESTADOS);
const getCidades = createAction(CIDADES);
const getProvincias = createAction(PROVINCIAS);
const getTiposVia = createAction(TIPOS_VIA);

export const actions = {
  searchAddress,
  updateAddressStore,
  getEstados,
  getCidades,
  getProvincias,
  getTiposVia,
};

// INITIAL STATE
const initialState = {};

// REDUCERS
const reducer = handleActions(
  {
    [UPDATE_STORE]: (state, action) => {
      return {
        ...state,
        endereco: action.payload,
      };
    },
  },
  initialState,
);

export default reducer;

// SELECTORS
const getAddress = (state) => state.endereco.endereco;

export const selectors = {
  getAddress,
};
